const RecoveryFormMessages = {
  FormH1: 'Recuperar contraseña',
  placeHolderInput1: 'Email',
  textButton: 'Solicitar',
  accesText: 'Ingresar al sitio'
}

export default RecoveryFormMessages
